module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": true
    },
    on: {
      "close": _vm.closeModalLocal
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-header",
    style: ('background-image:url(' + (_vm.unit && _vm.unit.pool && _vm.unit.pool.image) + ')')
  }, [(_vm.unit) ? _c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        " + _vm._s((_vm.unit.display_name || _vm.unit.description_title)) + "\n      ")]) : _vm._e()])]), _vm._v(" "), (_vm.unit) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "content-left"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    class: [
      'tab',
      _vm.activeTab === 'info' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('info')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "info-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Beskrivning")])], 1), _vm._v(" "), _c('div', {
    class: [
      'tab',
      _vm.activeTab === 'images' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('images')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "img-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "img-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Bilder")])], 1), _vm._v(" "), _c('div', {
    class: [
      'tab',
      _vm.activeTab === 'map' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('map')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "map-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "map-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Karta")])], 1), _vm._v(" "), _c('div', {
    class: [
      'tab',
      _vm.activeTab === 'video' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('video')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "play-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "play-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Film")])], 1)]), _vm._v(" "), (_vm.activeTab === 'info') ? _c('div', {
    staticClass: "info",
    domProps: {
      "innerHTML": _vm._s(_vm.nl2br(_vm.unit.description_full))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'images') ? _c('div', {
    staticClass: "images"
  }, [_c('agile', {
    attrs: {
      "arrows": true,
      "speed": 200,
      "timing": 'linear',
      "fade": false,
      "autoplay": false,
      "arrow": "<img src=\"https://static.booking.branasgruppen.se/static/svg/arrow-slideshow-left.svg\" />"
    }
  }, _vm._l((_vm.unit.images), function(image) {
    return _c('div', {
      staticClass: "slide"
    }, [_c('img', {
      attrs: {
        "src": image.path_corrected
      }
    })])
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'video') ? _c('div', {
    staticClass: "video"
  }, [_c('Vimeo', {
    attrs: {
      "url": _vm.unit.pool.video
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-right"
  }, [(_vm.arrival) ? _c('AccomodationPeriodConfirm', {
    staticClass: "tighter",
    attrs: {
      "unit": _vm.unit,
      "arrival": _vm.arrival,
      "departure": _vm.departure
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$store.state.tempCartAccomodation.period) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.openModal(['UnitPriceModal', {
          unit: _vm.unit
        }])
      }
    }
  }, [_vm._v("Priser och tillgänglighet "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.2
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.tempCartAccomodation.period) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.chooseAccomodation({
          pool_lid: _vm.unit.pool_lid,
          unit_lid: _vm.unit.unit_lid,
          period: _vm.$store.state.tempCartAccomodation.period,
          week: _vm.$store.state.tempCartAccomodation.period.week,
          name: (_vm.unit.display_name || _vm.unit.description_title),
          capacity: _vm.unit.capacity,
          price: _vm.$store.state.tempCartAccomodation.period.price
        })
      }
    }
  }, [_vm._v("Välj "), _c('icon', {
    attrs: {
      "name": "cart-white",
      "scale": 1.2
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart",
      "scale": 1.5
    }
  }), _vm._v(" Spara\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart-red",
      "scale": 1.5
    }
  }), _vm._v(" Ta bort\n      ")], 1) : _vm._e(), _vm._v(" "), _c('UnitFacts', {
    attrs: {
      "unit": _vm.unit
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (false) ? _c('pre', [_vm._v(_vm._s(_vm.unit))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-430d3e84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/deprecated/UnitInfoModal.vue
// module id = 961
// module chunks = 0